export default __webpack_public_path__ + "static/media/filter-gray.06e5eda5.svg";